import { Component, ElementRef, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { SharedService } from 'src/app/core/services/shared.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { EventService } from 'src/app/core/services/event.service';
import { JSEncrypt } from 'jsencrypt';
import { formatNumber } from '@angular/common';


// mospina 10-10-16 EPT-2562 SCG-459 Integracion Yappy
// Script del boton de pago Yappy (Web Component). Dejar activo el del ambiente correspondiente.
export const URL_YAPPY_BOTON = 'https://bt-cdn-uat.yappycloud.com/v1/cdn/web-component-btn-yappy.js';   // Pruebas (UAT)
//export const URL_YAPPY_BOTON = 'https://bt-cdn.yappy.cloud/v1/cdn/web-component-btn-yappy.js';       // Produccion

const METODOS_CON_TARJETA = ['GP', 'WPI', 'CCT'];
const METODOS_REDIRECCION = ['BCR', 'CCB'];
const METODOS_APP = ['YAP'];
const YAPPY_CONSULTA_MS = 4000;
const YAPPY_LIMITE_SEG = 300;
const YAPPY_CIERRE_MS = 5000;
let promesaScriptYappy: Promise<void> | null = null;
let huboPagoYappy = false;
const KOUNT_AMBIENTE = 'sand';
const GREENPAY_PUBKEY_RESPALDO = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDjIMRSINNi+ar5gs7w3zMNquy9MKTOhIQUeqXdvqbi+0/wEGALT4p1aQxVh28qyUjJkld1SoXhLeIeVXyGHwwaxNAJCLtg6Pk0Co0x0Y50bbLyAjMkwita5bCBvSYvD7/Hn2y0pvUjqTLo9oEqHUQyMunz1w4755PV4pxKSCl+nwIDAQAB';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})

export class CheckoutComponent implements OnInit, OnDestroy {

  checkoutForm: FormGroup;
  cardForm!: FormGroup;

  selectValue = [];
  activeTab = 1;
  errores = [];
  AceptaTerminos = false;
  metodoPagoSeleccionado = "";
  filtrosList = [];
  totalMontoFormateado = '';
  totalMonto = 0;
  transaccion = 0;
  M12CAR = "";
  session = "";
  token = ""
  respuestaPago: any = null;
  respuestaPagoCrediCorp: any = null;
  respuestaPagoGeneral: boolean = false;
  moneda = "";
  email = "";
  acceptance_token_wompi = "";
  access_token_credicorp = "";
  link_contrato: SafeResourceUrl;
  allowTabChange = false;
  errorCrediCorp = "";
  GDataCollector: any;
  collector: any;
  kountSession: string | null = null;
  lstTiposPago = [];
  terminarPago: boolean = false;
  @Input() JSONllavesMantenimiento;
  @Input() tabId;
  @Input() SYS02CON_PAPA: string;
  @Input() dataContext: any; 

  login: string  = '';
  secretKey: string = '';

  processUrlBCR: string = '';
  requestIdBCR: string = '';

  procesando = false;
  metodoTransaccion = "";
  greenPayPubKey = "";

  mostrarReverso = false;

  mensajeError = "";
  cargandoMetodos = true;
  cargandoDatos = true;
  descargaContrato: SafeUrl | null = null;
  fechaRespuesta: Date | null = null;

  aliasYappy = '';
  yappyListo = false;
  yappyDisponible: boolean | null = null;
  private yappyVerificacion: any = null;
  yappyEsperando = false;
  yappySinRespuesta = false;
  yappyRestanteSeg = YAPPY_LIMITE_SEG;
  private yappyConsultando = false;
  private yappyConsulta: any = null;
  private yappyReloj: any = null;

  @ViewChild('btnYappy') set btnYappyRef(ref: ElementRef) {
    if (ref) {
      this.yappyBoton = ref.nativeElement;
      this.conectarBotonYappy(ref.nativeElement);
    }
  }
  private yappyBoton: any = null;
  private yappyCerrando = false;
  yappyFinalizando = false;

  constructor(private dataService: SharedService, private fb: FormBuilder, private sanitizer: DomSanitizer, private eventService: EventService, private ngZone: NgZone) { }

  ngOnInit() {
    
    this.checkoutForm = this.fb.group({
      billingName: ['', Validators.required],
      billingEmail: ['', [Validators.required, Validators.email]],
      billingPhone: ['', [Validators.required, Validators.pattern('^[0-9]+$')]], 
      billingAddress: ['', Validators.required],
      country: ['', Validators.required]
    });

    this.cardForm = this.fb.group({
      cardNumber: ['', [Validators.required, this.validarNumeroTarjeta]],
      cardName: ['', Validators.required],
      expiryDate: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[0-2])\/\d{2}$/), this.validarExpiracion]],
      cvv: ['', [Validators.required, Validators.pattern(/^\d{3,4}$/)]],
      installments: ['1', Validators.required],
    });

    this.getConfiguraciones();
    this.getPaises();
    this.getResumen();

    this.inicializarCollector();
    
  }

  inicializarCollector(){
    window.GDataCollector.init(KOUNT_AMBIENTE, null, (result: any) => {
      this.collector = result;

      this.collector.setupCallback({
        "collect-end": (params: any) => {
          this.kountSession = params.MercSessId;
        },
        "collect-begin": () => {
        }
      });

      this.collector.collectData();
    });
  }

  get requiereTarjeta(): boolean {
    return METODOS_CON_TARJETA.includes(this.metodoPagoSeleccionado);
  }

  get esRedireccion(): boolean {
    return METODOS_REDIRECCION.includes(this.metodoPagoSeleccionado);
  }

  get esPagoApp(): boolean {
    return METODOS_APP.includes(this.metodoPagoSeleccionado);
  }

  get aliasYappyValido(): boolean {
    return /^[0-9]{8}$/.test(this.aliasYappy);
  }

  private get digitosTarjeta(): string {
    return String(this.cardForm?.get('cardNumber')?.value || '').replace(/\D/g, '');
  }

  get marcaTarjeta(): string {
    const d = this.digitosTarjeta;
    if (/^4/.test(d)) { return 'visa'; }
    if (/^(5[1-5]|22[2-9]|2[3-6]|27[01]|2720)/.test(d)) { return 'mastercard'; }
    if (/^3[47]/.test(d)) { return 'amex'; }
    if (/^3(0[0-5]|[689])/.test(d)) { return 'diners'; }
    if (/^(6011|65|64[4-9])/.test(d)) { return 'discover'; }
    return '';
  }

  get nombreMarca(): string {
    const nombres: Record<string, string> = { visa: 'VISA', mastercard: 'Mastercard', amex: 'American Express', diners: 'Diners Club', discover: 'Discover' };
    return nombres[this.marcaTarjeta] || '';
  }

  get numeroVista(): string {
    const d = this.digitosTarjeta;
    const esAmex = this.marcaTarjeta === 'amex';
    const largo = Math.max(esAmex ? 15 : 16, d.length);
    const completo = (d + '•'.repeat(largo)).substring(0, largo);
    const grupos = esAmex ? [4, 6, 5] : [];
    if (grupos.length) {
      return [completo.substring(0, 4), completo.substring(4, 10), completo.substring(10)].join(' ');
    }
    return completo.replace(/(.{4})(?=.)/g, '$1 ');
  }

  get cvvVista(): string {
    const largo = String(this.cardForm?.get('cvv')?.value || '').length;
    return largo ? '•'.repeat(largo) : '•••';
  }

  get metodoSeleccionadoInfo(): any {
    return this.lstTiposPago.find(p => p.FUENTE === this.metodoPagoSeleccionado) || null;
  }

  nextTab() {
    this.mensajeError = "";
    if (this.activeTab < 4) { 
      this.activeTab++;
    }
    if (this.activeTab == 3 && this.esRedireccion) {
      this.activeTab = 4;
    }
    if(this.activeTab == 2){
      this.getDatosPago();
    }
    if(this.activeTab == 4){
      this.validarFormGeneral();
    }
  }

  prevTab() {
    this.mensajeError = "";
    if (this.activeTab > 1) {  
      this.activeTab--;
    }
    if (this.activeTab == 3 && this.esRedireccion) {
      this.activeTab = 2;
    }
  }

  setTab(tabIndex: number) {
    this.activeTab = tabIndex;
    if(this.activeTab == 2){
      this.getDatosPago();
    }
    if(this.activeTab == 4){
      this.validarFormGeneral();
    }
  }

  onPay(){
    if (this.procesando) {
      return;
    }
    let envio = this.validarFormGeneral();
    if(envio){
      this.procesando = true;
      if(this.metodoPagoSeleccionado == "BCR"){
        this.webCheckoutBCR(this.transaccion);
      }else if(this.metodoPagoSeleccionado == "GP"){
        this.startEncryption();
      }else if(this.metodoPagoSeleccionado == "WPI"){
        this.generarPagoWompi();
      }else if(this.metodoPagoSeleccionado == "CCB"){
        this.generarPagoCrediCorp();
      }else if(this.metodoPagoSeleccionado == "CCT"){
        this.generarPagoCrediCorpTC();
      }else{
        this.procesando = false;
      }
    }
  }

  validarFormGeneral() {

    let envio = false;

    const campoTraducciones = {
      billingName: 'Nombre',
      billingEmail: 'Correo Electrónico',
      billingPhone: 'Teléfono',
      billingAddress: 'Dirección',
      country: 'País',
      cardNumber: 'Número de Tarjeta',
      cardName: 'Nombre de la Tarjeta',
      expiryDate: 'Fecha de Expiración',
      cvv: 'Código CVV',
      installments: 'Cuotas'
    };
  
    let missingFields = [];
    this.errores = [];
  
    if (this.checkoutForm.invalid) {
      const checkoutInvalidFields = this.getInvalidFields(this.checkoutForm);
      if (checkoutInvalidFields.length > 0) {
        missingFields.push({ form: 'Información Personal', fields: checkoutInvalidFields });
      }
    }

    if(this.requiereTarjeta){
      if (this.cardForm.invalid) {
        const paymentInvalidFields = this.getInvalidFields(this.cardForm);
        if (paymentInvalidFields.length > 0) {
          missingFields.push({ form: 'Información de Pago', fields: paymentInvalidFields });
        }
      }
    }
  
    if (this.esPagoApp && !this.aliasYappyValido) {
      missingFields.push({ form: 'Yappy', fields: ['Número de celular Yappy (8 dígitos)'] });
    }

    if (!this.AceptaTerminos) {
      missingFields.push({ form: 'Confirmación', fields: ['Debe aceptar los Términos y Condiciones'] });
    }

    if (!this.transaccion) {
      missingFields.push({ form: 'Transacción', fields: ['No se generó la transacción de pago. Vuelva al paso de Términos y Condiciones.'] });
    }
  
    if (missingFields.length > 0) {
      this.errores = [];
      missingFields.forEach(group => {
        this.errores.push(`<strong>${group.form}:</strong>`);
        group.fields.forEach(field => {
          const campoTraducido = campoTraducciones[field] || field;
          this.errores.push(`${campoTraducido}`);
        });
      });
      envio = false;
    } else {
      envio = true;
    }

    return envio;
  }  

  private getInvalidFields(form: FormGroup): string[] {
    const invalidFields = [];
    Object.keys(form.controls).forEach(field => {
      if (form.controls[field].invalid) {
        invalidFields.push(field);
      }
    });
    return invalidFields;
  }

  formatCardNumber(event: any): void {
    let value = event.target.value;
  
    value = value.replace(/\D/g, '');
  
    value = value.substring(0, 19);
    const formattedValue = value.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
  
    event.target.value = formattedValue;
    this.cardForm.get('cardNumber')?.setValue(formattedValue, { emitEvent: false });
  }

  validarNumeroTarjeta(control: AbstractControl): ValidationErrors | null {
    const digitos = String(control.value || '').replace(/\D/g, '');
    if (!digitos) {
      return null;
    }
    if (digitos.length < 13 || digitos.length > 19) {
      return { tarjeta: true };
    }
  
    let suma = 0;
    let duplicar = false;
    for (let i = digitos.length - 1; i >= 0; i--) {
      let digito = parseInt(digitos.charAt(i), 10);
      if (duplicar) {
        digito *= 2;
        if (digito > 9) {
          digito -= 9;
        }
      }
      suma += digito;
      duplicar = !duplicar;
    }
    return suma % 10 === 0 ? null : { tarjeta: true };
  }
  
  validarExpiracion(control: AbstractControl): ValidationErrors | null {
    const valor = String(control.value || '');
    const partes = valor.match(/^(0[1-9]|1[0-2])\/(\d{2})$/);
    if (!partes) {
      return null;
    }
    const mes = parseInt(partes[1], 10);
    const anio = 2000 + parseInt(partes[2], 10);
    const hoy = new Date();
    const vencida = anio < hoy.getFullYear() || (anio === hoy.getFullYear() && mes < hoy.getMonth() + 1);
    return vencida ? { vencida: true } : null;
  }  
  
  onExpiryDateInput(event: any) {
    let input = event.target.value.replace(/\D/g, '');
  
    if (input.length > 4) {
      input = input.substring(0, 4);
    }
  
    if (input.length > 2) {
      input = input.substring(0, 2) + '/' + input.substring(2);
    }
    this.cardForm.get('expiryDate')?.setValue(input, { emitEvent: false });
  }

  onCVVInput(event: any) {
    let input = event.target.value.replace(/\D/g, ''); 
  
    if (input.length > 4) {
      input = input.substring(0, 4);
    }
    this.cardForm.get('cvv')?.setValue(input, { emitEvent: false });
  }

  getConfiguraciones(){
    let objetoJSON = JSON.parse(this.JSONllavesMantenimiento);

    this.dataService.Consultar("api/ws/cnt/CNT05ARC_WS/ConfiguracionApis", objetoJSON).subscribe((datos) => {
      this.lstTiposPago = datos[0].CONFIGURACION_APIS || [];
      this.cargandoMetodos = false;
      
      if (this.lstTiposPago.length > 0) {
        this.metodoPagoSeleccionado = this.lstTiposPago[0].FUENTE;
        this.seleccionarContrato();
      }
    },
    error => {
      this.cargandoMetodos = false;
      this.mostrarError(error);
    });
  }

  seleccionarContrato() {
    this.AceptaTerminos = false;

    this.lstTiposPago.forEach(element => {
      if (element.FUENTE === this.metodoPagoSeleccionado) {
        const pdfBase64 = element.TERM_CONDICIONES || '';
        const cleanedBase64 = pdfBase64.replace(/\s/g, ''); 
        const base64Url = `data:application/pdf;base64,${cleanedBase64}`;
        this.link_contrato = this.sanitizer.bypassSecurityTrustResourceUrl(base64Url);
        this.descargaContrato = cleanedBase64 ? this.sanitizer.bypassSecurityTrustUrl(base64Url) : null;
      }
    });
  }  

  getPaises(){
    let objetoJSON = JSON.parse(this.JSONllavesMantenimiento);

    this.dataService.Consultar("api/ws/mge/M12ARC_WS/Paises", objetoJSON).subscribe((datos) => {
      let paises = [];

      for (let index = 0; index < datos[0].PAISES.length; index++) {
        let pais = datos[0].PAISES[index];
        paises.push({ value: String(pais["M09COD"]).trim(), label: pais["M09DES"] });
      }

      this.selectValue = paises;
      this.getDatosPersonales();
    },
    error => {
      this.cargandoDatos = false;
      this.mostrarError(error);
    });
  }

  getDatosPersonales(){
    let objetoJSON = JSON.parse(this.JSONllavesMantenimiento);

    this.dataService.Consultar("api/ws/mge/M12ARC_WS/DatosPersonales", objetoJSON).subscribe((datos) => {
      let data = datos[0].DATOS_PERSONALES;
      this.email = data[0]["M12EMA"];
      
      this.checkoutForm.patchValue({
        billingName: data[0]["M12NOM"],
        billingEmail: data[0]["M12EMA"],
        billingPhone: data[0]["M12TEL"],
        billingAddress: data[0]["M12DIR"],
        country: this.buscarCodigoPais(data[0]["M09COD"])
      });
      this.cargandoDatos = false;
    },
    error => {
      this.cargandoDatos = false;
      this.mostrarError(error);
    });
  }

  private buscarCodigoPais(valor: any): string | null {
    if (valor === null || valor === undefined || String(valor).trim() === '') {
      return null;
    }
    const texto = String(valor).trim();
    const porCodigo = this.selectValue.find(p => p.value === texto);
    if (porCodigo) {
      return porCodigo.value;
    }
    const porNombre = this.selectValue.find(p => String(p.label).trim().toLowerCase() === texto.toLowerCase());
    return porNombre ? porNombre.value : null;
  }

  getResumen() {
    let objetoJSON = JSON.parse(this.JSONllavesMantenimiento);
  
    let filtrosOpcionales = objetoJSON.FILTROS_OPCIONALES;
    this.filtrosList = []; 
    let totalMonto = 0; 

    filtrosOpcionales.forEach(item => {
      let clave = Object.keys(item)[0]; 
      let filtro = item[clave];
      
      const montoItem = typeof filtro.M54TOT === 'string' 
        ? parseFloat(filtro.M54TOT.replace(/,/g, '')) 
        : filtro.M54TOT;
    
      totalMonto += montoItem; 
    
      this.filtrosList.push({
        INDEX: filtro.INDEX,
        M54DES: filtro.M54DES,
        M54MON: montoItem,  
        M54FEC: filtro.M54FEC,
        TIPO: filtro.TIPO,
        DESCRIPCION: filtro.DESCRIPCION,
        checkado: filtro.checkado
      });
    });

    if (totalMonto <= 0) {
      Swal.fire({
        title: 'Error',
        html: 'El monto total a pagar no es válido. Por favor, verifique los conceptos seleccionados.',
        icon: 'error',
        confirmButtonText: 'Cerrar'
      }).then(() => {
        this.onFinish();
      });
      return;
    }
  
    this.totalMontoFormateado = this.formatearMoneda(totalMonto);
    this.totalMonto = totalMonto;
  }

  getDatosPago(){

    if (this.transaccion && this.metodoTransaccion === this.metodoPagoSeleccionado) {
      return;
    }
    const metodoAnterior = this.metodoTransaccion;

    let strCNT05COD = "";
    let strM05COD   = "";

    let objetoJSON = JSON.parse(this.JSONllavesMantenimiento);

    let opcionales = objetoJSON.FILTROS_OPCIONALES;
    let obligatorio = objetoJSON.FILTROS_OBLIGATORIOS[0];

    if (!opcionales || opcionales.length == 0) {
      this.mostrarError('No hay conceptos seleccionados para pagar.');
      this.activeTab = 1;
      return;
    }

    let opcional = null;
    if (opcionales.length > 0) {
        let primerElemento = opcionales[0];

        let claves = Object.keys(primerElemento);

        let selectedIndex = claves[0]; 

        opcional = primerElemento[selectedIndex];  
    }

    if (obligatorio != null && obligatorio.M12CAR) {
      this.M12CAR = obligatorio.M12CAR;  
    } else if (opcional && opcional.M12CAR) {
      this.M12CAR = opcional.M12CAR; 
    } else {
      this.M12CAR = "";  
    }

    const key = Object.keys(opcionales[0])[0];
    const v = opcionales[0][key]; 

    const dataDinamico = opcionales.map((item: any) => {
      const keyInner = Object.keys(item)[0];
      const vInner = item[keyInner];
      strCNT05COD = vInner.CNT05COD;
      strM05COD = vInner.M05COD;
      return [
        ["TIPO", vInner.TIPO],
        vInner.TIPO == 'M54ARC' ? ["KEYS", `M12CAR=${this.M12CAR}@FAX03CON=${vInner.LLAVE1}`] : 
        vInner.TIPO == 'CXC21ARC' ? ["KEYS", `CXC20COD=${vInner.LLAVE1}@CXC21COD=${vInner.LLAVE2}@CNT05COD=${strCNT05COD}@CXC21NDO=${vInner.CLAVE4}`] :
        ["KEYS", `M05COD=${strM05COD}@FAC61NUM=${vInner.LLAVE1}`]
      ];
    });

    const llaves = {
      LLAVES: [
        {
          M12CAR: this.M12CAR,
          CNT05COD: strCNT05COD,
          M05COD: strM05COD,
          FAC73POS: this.metodoPagoSeleccionado,
          E64MON: this.totalMonto.toString(),
          CNT01COD: v.CNT01COD,
          DATA: dataDinamico
        }
      ]
    };

    const llavesJsonString = JSON.stringify(llaves);
  
    this.dataService.Ejecutar("api/ws/Checkout/datosPago", llavesJsonString).subscribe((datos) => {
      const respuesta = datos[0];
      this.transaccion = respuesta.FAC71CON;
      this.metodoTransaccion = this.metodoPagoSeleccionado;

      // Para BCR
      if (this.metodoPagoSeleccionado == "BCR") {
        // recibo llaves de comercio
        this.processUrlBCR = respuesta.processUrl || '';
        this.requestIdBCR = respuesta.requestId || '';
      }else if(this.metodoPagoSeleccionado == "GP"){
        this.session = respuesta.session;
        this.token = respuesta.token;
        this.greenPayPubKey = respuesta.PUBKEY || '';
      }else if(this.metodoPagoSeleccionado == "WPI"){
        this.acceptance_token_wompi = respuesta.acceptance_token;
        const url = respuesta.permalink; 
        this.link_contrato = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      }else if(this.metodoPagoSeleccionado == "CCB"){
        this.access_token_credicorp = respuesta.access_token;
      }
    },
    error => {
      this.mostrarError(error);
      if (metodoAnterior) {
        this.metodoPagoSeleccionado = metodoAnterior;
        this.seleccionarContrato();
      }
      this.activeTab = 1;
    });
  }

  abrirTerminosWompi() {
    let url = this.link_contrato;
    if (typeof url !== 'string') {
      url = (url as any).changingThisBreaksApplicationSecurity || '';
    }
    if (url) {
      const width = 1000;
      const height = 800;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;
      window.open(
        url.toString(),
        '_blank',
        `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars`
      );
    }
  }
  
  formatearMoneda(monto: number): string {
    return formatNumber(monto, 'en-US', '1.2-2');
  }  

  async startEncryption() {
    let strFECHAVENCIMIENTO = this.cardForm.get('expiryDate')?.value;
    let month = strFECHAVENCIMIENTO.substr(0, 2);
    let year = strFECHAVENCIMIENTO.substr(3, 2);
  
    const cardDataObject = {
      card: {
        cardHolder: this.cardForm.get('cardName')?.value,
        expirationDate: {
          month: parseInt(month),
          year: parseInt(year),
        },
        cardNumber: this.cardForm.get('cardNumber')?.value.replace(/\s+/g, ''),
        cvc: this.cardForm.get('cvv')?.value
      },
      tokenize: false,
      kountSession: this.kountSession
    };
  
    let cardDataEncrypted: { ld: string; lk: string };
    try {
      cardDataEncrypted = await this.pack(cardDataObject);
    } catch (e) {
      this.procesando = false;
      this.mostrarError('No fue posible cifrar los datos de la tarjeta.');
      return;
    }
  
    let llaves = {
      "LLAVES": [
        {
          "DATA": [
            ["ld", cardDataEncrypted.ld],
            ["session", this.session],
            ["token", this.token],
            ["FAC71CON", this.transaccion],
            ["lk", cardDataEncrypted.lk]
          ]
        }
      ]
    };
  
    const llavesJsonString = JSON.stringify(llaves);
  
    this.respuestaPagoGeneral = true;
  
    this.dataService.Ejecutar("api/ws/Checkout/checkout", llavesJsonString).subscribe((datos) => {
      this.respuestaPago = datos;
      this.fechaRespuesta = new Date();
      this.procesando = false;
    },
    error => {
      this.mostrarError(error);
      this.respuestaPagoGeneral = false;
      this.procesando = false;
    });
  }

  generarPagoWompi() {
    
    let strFECHAVENCIMIENTO = this.cardForm.get('expiryDate')?.value;
    let month = strFECHAVENCIMIENTO.substr(0, 2);
    let year = strFECHAVENCIMIENTO.substr(3, 2);
    let number = this.cardForm.get('cardNumber')?.value;
    let cvc = this.cardForm.get('cvv')?.value;
    let card_holder = this.cardForm.get('cardName')?.value;
    let installments = this.cardForm.get('installments')?.value;

    let llaves = {
      "LLAVES": [
        {
          "number": number.replace(/\s+/g, '').replace(/\D/g, ''),
          "cvc": cvc,
          "exp_month": month,
          "exp_year": year,
          "card_holder": card_holder,
          "amount_in_cents": this.totalMonto.toString(),
          "currency": 'USD',
          "customer_email": this.email,
          "acceptance_token": this.acceptance_token_wompi,
          "installments": installments,
          "FAC71CON": this.transaccion,
          "M12CAR": this.M12CAR
        }
      ]
    };
    
    const llavesJsonString = JSON.stringify(llaves);
    this.respuestaPagoGeneral = true;

    this.dataService.Ejecutar("api/ws/Checkout/GenerarPagoWompi", llavesJsonString).subscribe((datos) => {
      this.respuestaPago = datos[0];
      this.fechaRespuesta = new Date();
      this.procesando = false;
    },
    error => {
      this.mostrarError(error);
      this.respuestaPagoGeneral = false;
      this.terminarPago = true;
      this.procesando = false;
    });

  }

  generarPagoCrediCorp() {

    const ventana = window.open('', '_blank');

    let llaves = {
      "LLAVES": [
        {
          "amount": this.totalMonto.toString(),
          "currency": 'USD',
          "access_token": this.access_token_credicorp,
          "FAC71CON": this.transaccion,
          "M12CAR": this.M12CAR
        }
      ]
    };
    
    const llavesJsonString = JSON.stringify(llaves);

    this.dataService.Ejecutar("api/ws/Checkout/GenerarPagoCrediCorp", llavesJsonString).subscribe((datos) => {
      this.terminarPago = true;
      this.procesando = false;
      this.irAPortalPago(ventana, datos[0].url);
    },
    error => {
      this.cerrarVentana(ventana);
      this.mostrarError(error);
      this.respuestaPagoGeneral = false;
      this.terminarPago = true;
      this.procesando = false;
    });

  }

  generarPagoCrediCorpTC() {

    let strFECHAVENCIMIENTO = this.cardForm.get('expiryDate')?.value;
    let month = strFECHAVENCIMIENTO.substr(0, 2);
    let year = strFECHAVENCIMIENTO.substr(3, 2);
    let number = this.cardForm.get('cardNumber')?.value;
    let cvc = this.cardForm.get('cvv')?.value;
    let card_holder = this.cardForm.get('cardName')?.value;
    let installments = this.cardForm.get('installments')?.value;

    let llaves = {
      "LLAVES": [
        {
          "number": number.replace(/\s+/g, '').replace(/\D/g, ''),
          "cvc": cvc,
          "exp_month": month,
          "exp_year": year,
          "card_holder": card_holder,
          "amount_in_cents": this.totalMonto.toString(),
          "currency": 'USD',
          "customer_email": this.email,
          "installments": installments,
          "FAC71CON": this.transaccion,
          "M12CAR": this.M12CAR
        }
      ]
    };
    
    const llavesJsonString = JSON.stringify(llaves);
    this.respuestaPagoGeneral = true;

    this.dataService.Ejecutar("api/ws/Checkout/GenerarPagoCrediCorpTC", llavesJsonString).subscribe((datos) => {
      this.respuestaPago = datos;
      this.fechaRespuesta = new Date();
      this.procesando = false;
    },
    error => {
      this.mostrarError(error);
      this.respuestaPagoGeneral = false;
      this.terminarPago = true;
      this.procesando = false;
    });

  }

  async pack(obj: any): Promise<{ ld: string; lk: string }> {
    // 1) Generar la key AES (16 bytes = 128 bits)
    const rawKey = new Uint8Array(16);
    window.crypto.getRandomValues(rawKey);
  
    // 2) Generar el counter (solo un número aleatorio 0?255)
    const s = Math.floor(Math.random() * 256);
  
    // 3) Preparar el texto en bytes
    const encoder = new TextEncoder();
    const data = encoder.encode(JSON.stringify(obj));
  
    // 4) Crear una clave AES-CTR a partir de rawKey
    const aesKey = await window.crypto.subtle.importKey(
      "raw",
      rawKey,
      { name: "AES-CTR" },
      false,
      ["encrypt"]
    );
  
    // 5) Definir el counter como objeto de 16 bytes con `s` en la última posición
    const counterArray = new Uint8Array(16);
    counterArray[15] = s; 
  
    // 6) Cifrar los datos con AES-CTR
    const encrypted = await window.crypto.subtle.encrypt(
      { name: "AES-CTR", counter: counterArray, length: 128 },
      aesKey,
      data
    );
  
    // 7) Convertir el resultado a HEX (ld)
    const encryptedHex = Array.from(new Uint8Array(encrypted))
      .map(b => b.toString(16).padStart(2, "0"))
      .join("");
  
    // 8) Preparar el par de llaves como en el original
    const pair = { k: Array.from(rawKey), s };
  
    // 9) Cifrar con RSA ese JSON (lk)
    const rsa = new JSEncrypt();
    rsa.setPublicKey(this.greenPayPubKey || GREENPAY_PUBKEY_RESPALDO);
  
    const encryptedRSA = rsa.encrypt(JSON.stringify(pair));
    if (!encryptedRSA) {
      throw new Error("RSA encryption failed");
    }
  
    return {
      ld: encryptedHex,
      lk: encryptedRSA
    };
  }

  onFinish() {
    this.eventService.broadcast('cerrar_tab', this.tabId);
  }

  onFinishPay() {
    if (this.SYS02CON_PAPA) {
      this.eventService.broadcast('recargar_tab', this.SYS02CON_PAPA);
    }
  
    this.eventService.broadcast('cerrar_tab', this.tabId);
  }
  
  hasLogo(logo: string | null | undefined): boolean {
    if (logo == null) return false;            
    const trimmed = String(logo).trim();
    if (trimmed === '') return false;      
    if (trimmed.toLowerCase() === 'null') return false; 
    return true;
  }

  webCheckoutBCR(FAC71CON: any) {
    const processUrl = this.processUrlBCR;
    const requestId = this.requestIdBCR;
    const FAC71 = this.transaccion;
  
    if (!processUrl || !requestId) {
      this.procesando = false;
      this.mostrarError('No se encontró la sesión de pago. Vuelve al paso de Términos e intenta de nuevo.');
      return;
    }

    const ventana = window.open('', '_blank');
  
    let llaves = {
      "LLAVES": [
        {
          "FAC71CON": FAC71,
          "requestId": requestId.toString()
        }
      ]
    };
  
    const llavesJsonString = JSON.stringify(llaves);
    this.respuestaPagoGeneral = true;

this.dataService.Ejecutar("api/ws/Checkout/GenerarPagoBCR", llavesJsonString).subscribe(
  (datos) => {
    this.respuestaPagoGeneral = false;
    this.terminarPago = true;
    this.allowTabChange = false;      
    this.procesando = false;
    if (this.checkoutForm && (this.checkoutForm.disable instanceof Function)) {
      try { this.checkoutForm.disable(); } catch (e) {}
    }

    this.irAPortalPago(ventana, processUrl);
  },
  error => {
    this.respuestaPagoGeneral = false;
    this.terminarPago = true;
    this.procesando = false;
    this.cerrarVentana(ventana);
    this.mostrarError(error);
  }
);
  }

  private irAPortalPago(ventana: Window | null, url: string) {
    if (!url) {
      this.cerrarVentana(ventana);
      this.mostrarError('El portal de pago no devolvió una dirección válida.');
      return;
    }
    if (ventana && !ventana.closed) {
      ventana.location.href = url;
      try { ventana.focus(); } catch (e) {}
      return;
    }
    Swal.fire({
      title: 'Continúa en el portal de pago',
      html: 'Tu navegador bloqueó la ventana del portal de pago.<br>' +
            '<a href="' + encodeURI(url) + '" target="_blank" rel="noopener">Haz clic aquí para abrirlo</a>',
      icon: 'info',
      confirmButtonText: 'Cerrar'
    });
  }

  private cerrarVentana(ventana: Window | null) {
    try { if (ventana && !ventana.closed) { ventana.close(); } } catch (e) {}
  }

  private mostrarError(error: any) {
    const mensaje = typeof error === 'string'
      ? error
      : (error?.error?.message || error?.message || 'Ocurrió un error inesperado. Intente de nuevo.');
    this.mensajeError = mensaje || 'Ocurrió un error inesperado. Intente de nuevo.';
    setTimeout(() => {
      const aviso = document.getElementById('ck-aviso-error');
      if (aviso) {
        aviso.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  cerrarError() {
    this.mensajeError = "";
  }

  get monedaPago(): string {
    return this.metodoPagoSeleccionado == 'GP' ? 'CRC' : 'USD';
  }

  get simboloMoneda(): string {
    return this.simboloDe(this.monedaPago);
  }

  simboloDe(moneda: string): string {
    return String(moneda || '').toUpperCase() == 'CRC' ? '₡' : '$';
  }

  private textoUtil(valor: any): string {
    const texto = valor === null || valor === undefined ? '' : String(valor).trim();
    return /^-*$/.test(texto) ? '' : texto;
  }

  get ultimosDigitos(): string {
    const d = this.digitosTarjeta;
    return d.length >= 4 ? d.substring(d.length - 4) : '';
  }

  get comprobante(): any {
    const r = this.respuestaPago;
    if (!r) {
      return null;
    }
    const metodo = this.metodoSeleccionadoInfo;
    const base = {
      metodo: metodo ? metodo.DESCRIPCION : this.metodoPagoSeleccionado,
      logo: metodo && this.hasLogo(metodo.LOGO) ? metodo.LOGO : '',
      transaccion: this.transaccion,
      tarjeta: this.ultimosDigitos,
      conceptos: this.filtrosList
    };

    if (this.metodoPagoSeleccionado == 'WPI') {
      const aprobado = r.status == 'APPROVED';
      return { ...base,
        aprobado,
        estado: r.status,
        autorizacion: r.id,
        referencia: r.reference,
        idTransaccion: '',
        monto: (Number(r.amount_in_cents) || 0) / 100,
        moneda: r.currency,
        fecha: r.created_at ? new Date(r.created_at) : this.fechaRespuesta,
        mensaje: this.textoUtil(r.status_message),
        error: ''
      };
    }

    if (this.metodoPagoSeleccionado == 'GP') {
      const aprobado = r.response_code == '1';
      return { ...base,
        aprobado,
        estado: aprobado ? 'APPROVED' : 'DECLINED',
        autorizacion: r.auth_code,
        referencia: r.orderId,
        idTransaccion: r.trans_id,
        monto: Number(r.amount) || 0,
        moneda: r.currency || 'CRC',
        fecha: this.fechaRespuesta,
        mensaje: r.response_reason_code == '00'
          ? ('Su operación se ha realizado con éxito. Autorización #' + r.auth_code)
          : 'Ha ocurrido un error inesperado, intente nuevamente en 5 minutos.',
        error: !aprobado && r.status ? r.message : ''
      };
    }

    if (this.metodoPagoSeleccionado == 'CCT') {
      const aprobado = r.response == '1';
      return { ...base,
        aprobado,
        estado: aprobado ? 'APPROVED' : 'DECLINED',
        autorizacion: r.authcode,
        referencia: this.transaccion,
        idTransaccion: r.transactionid,
        monto: this.totalMonto,
        moneda: 'USD',
        fecha: this.fechaRespuesta,
        mensaje: r.response_code === '100'
          ? ('Su operación se ha realizado con éxito. Autorización #' + r.authcode)
          : 'Ha ocurrido un error inesperado, intente nuevamente en 5 minutos.',
        error: !aprobado ? (r.responsetext || r.message) : ''
      };
    }

    if (this.metodoPagoSeleccionado == 'YAP') {
      const aprobado = r.estado == 'E';
      const estados: Record<string, string> = { E: 'EJECUTADO', R: 'RECHAZADO', C: 'CANCELADO', X: 'EXPIRADO' };
      return { ...base,
        tarjeta: '',
        aprobado,
        estado: estados[r.estado] || 'RECHAZADO',
        autorizacion: r.autorizacion,
        referencia: r.orderId,
        idTransaccion: r.transactionId,
        monto: Number(r.monto) || this.totalMonto,
        moneda: 'USD',
        fecha: r.fecha ? new Date(r.fecha) : this.fechaRespuesta,
        mensaje: aprobado
          ? (r.aplicado ? 'Tu pago con Yappy fue confirmado y aplicado.' : 'Tu pago con Yappy fue confirmado. El recibo se aplicará en unos minutos.')
          : (this.textoUtil(r.mensaje) || 'El pago con Yappy no se completó.'),
        error: '',
        reintentar: !aprobado
      };
    }

    return null;
  }

  ngOnDestroy() {
    if (this.yappyVerificacion) { clearInterval(this.yappyVerificacion); this.yappyVerificacion = null; }
    this.detenerEsperaYappy();
    this.cerrarModalYappy();
  }

  onAliasYappy(input: HTMLInputElement) {
    const digitos = String(input.value || '').replace(/\D/g, '').slice(0, 8);
    input.value = digitos;
    this.aliasYappy = digitos;
  }

  get relojYappy(): string {
    const s = Math.max(0, this.yappyRestanteSeg);
    return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
  }

  private cargarScriptYappy(): Promise<void> {
    if (window.customElements && window.customElements.get('btn-yappy')) {
      return Promise.resolve();
    }
    if (!promesaScriptYappy) {
      promesaScriptYappy = new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = URL_YAPPY_BOTON;
        script.onload = () => { window.customElements.whenDefined('btn-yappy').then(() => resolve()); };
        script.onerror = () => { promesaScriptYappy = null; reject(); };
        document.head.appendChild(script);
      });
    }
    return promesaScriptYappy;
  }

  private conectarBotonYappy(boton: any) {
    if (boton.__avatarConectado) {
      return;
    }
    boton.__avatarConectado = true;

    this.cargarScriptYappy().then(
      () => this.ngZone.run(() => { this.yappyListo = true; this.esperarYappyEnLinea(boton); }),
      () => this.ngZone.run(() => this.mostrarError('No se pudo cargar el botón de Yappy. Revisa tu conexión e intenta de nuevo.'))
    );

    boton.addEventListener('eventClick', () => this.ngZone.run(() => this.iniciarPagoYappy(boton)));
    boton.addEventListener('isYappyOnline', (evento: any) => this.ngZone.run(() => {
      if (this.yappyVerificacion) { clearInterval(this.yappyVerificacion); this.yappyVerificacion = null; }
      this.yappyDisponible = evento?.detail !== false;
    }));
    boton.addEventListener('eventSuccess', () => this.ngZone.run(() => this.consultarEstadoYappy()));
    boton.addEventListener('eventError', (evento: any) => this.ngZone.run(() => {
      if (!this.yappyEsperando && !this.yappyCerrando) {
        this.procesando = false;
        this.mostrarError(evento?.detail?.message || 'Yappy no pudo iniciar el pago. Intenta de nuevo.');
      }
    }));
  }

  private esperarYappyEnLinea(boton: any) {
    if (this.yappyVerificacion) { clearInterval(this.yappyVerificacion); }
    this.yappyDisponible = null;
    const inicio = Date.now();
    this.ngZone.runOutsideAngular(() => {
      this.yappyVerificacion = setInterval(() => {
        const enLinea = boton.isYappyOnline;
        const ms = Date.now() - inicio;
        let resultado: boolean | null = null;
        if (enLinea === true) resultado = true;                              // listo
        else if (enLinea === undefined && ms > 1500) resultado = true;       // el componente no expone la propiedad
        else if (ms > 8000) resultado = enLinea === false ? false : true;    // tiempo máximo de verificación
        if (resultado !== null) {
          clearInterval(this.yappyVerificacion);
          this.yappyVerificacion = null;
          this.ngZone.run(() => { this.yappyDisponible = resultado; });
        }
      }, 250);
    });
  }

  private iniciarPagoYappy(boton: any) {
    if (this.procesando || this.yappyEsperando || this.yappyFinalizando) {
      boton.isButtonLoading = false;
      return;
    }
    if (boton.isYappyOnline === false) {
      boton.isButtonLoading = false;
      this.mostrarError('Yappy no está disponible en este momento. Intenta más tarde o elige otro método de pago.');
      return;
    }
    if (!this.validarFormGeneral()) {
      boton.isButtonLoading = false;
      return;
    }

    this.mensajeError = '';
    this.procesando = true;
    boton.isButtonLoading = true;

    const llaves = {
      LLAVES: [{
        FAC71CON: this.transaccion,
        ALIAS: this.aliasYappy,
        TOTAL: this.totalMonto.toString()
      }]
    };

    this.dataService.Ejecutar('api/ws/Checkout/GenerarOrdenYappy', JSON.stringify(llaves)).subscribe((datos) => {
      const orden = datos[0] || {};

      if (!orden.transactionId || !orden.token || !orden.documentName) {
        console.warn('[Yappy] La orden llegó incompleta', orden);
        boton.isButtonLoading = false;
        this.procesando = false;
        this.mostrarError('No fue posible iniciar el pago con Yappy. Intenta nuevamente.');
        return;
      }

      this.limpiarAlmacenamientoYappy();
      this.cerrarModalYappy();
      const listo = typeof boton.componentOnReady === 'function' ? boton.componentOnReady() : Promise.resolve();
      Promise.resolve(listo).then(() => {
        setTimeout(() => this.ngZone.run(() => {
          try {
            if (typeof boton.eventPayment !== 'function') {
              throw new Error('el boton no expone eventPayment');
            }
            boton.eventPayment({
              transactionId: orden.transactionId,
              documentName: orden.documentName,
              token: orden.token
            });
            console.info('[Yappy] modal solicitado para la orden', orden.orderId || orden.transactionId);
            this.iniciarEsperaYappy();
          } catch (e) {
            console.warn('[Yappy] No se pudo abrir el modal de Yappy', e);
            boton.isButtonLoading = false;
            this.procesando = false;
            this.mostrarError('No fue posible abrir Yappy. Intenta nuevamente.');
          }
        }), 0);
      });
    },
    error => {
      boton.isButtonLoading = false;
      this.procesando = false;
      this.mostrarError(error);
    });
  }

  private iniciarEsperaYappy() {
    huboPagoYappy = true;
    this.detenerEsperaYappy();
    this.yappyEsperando = true;
    this.yappySinRespuesta = false;
    this.yappyRestanteSeg = YAPPY_LIMITE_SEG;

    this.yappyReloj = setInterval(() => this.ngZone.run(() => {
      this.yappyRestanteSeg--;
      if (this.yappyRestanteSeg <= 0) {
        this.detenerEsperaYappy();
        this.yappyEsperando = false;
        this.yappySinRespuesta = true;
        this.procesando = false;
        this.terminarPago = true;
        this.consultarEstadoYappy();
      }
    }), 1000);

    this.yappyConsulta = setInterval(() => this.ngZone.run(() => this.consultarEstadoYappy()), YAPPY_CONSULTA_MS);
  }

  private detenerEsperaYappy() {
    if (this.yappyReloj) { clearInterval(this.yappyReloj); this.yappyReloj = null; }
    if (this.yappyConsulta) { clearInterval(this.yappyConsulta); this.yappyConsulta = null; }
  }

  private consultarEstadoYappy() {
    if (!this.transaccion || this.yappyConsultando) {
      return;
    }
    this.yappyConsultando = true;
    const llaves = { LLAVES: [{ FAC71CON: this.transaccion }], spinner: 'N' };

    this.dataService.Ejecutar('api/ws/Checkout/ConsultarEstadoYappy', JSON.stringify(llaves)).subscribe((datos) => {
      this.yappyConsultando = false;
      const r = datos[0];
      if (r && r.estado && r.estado !== 'P') {
        this.detenerEsperaYappy();
        this.yappyFinalizando = true;
        setTimeout(() => {
          this.dataService.Ejecutar('api/ws/Checkout/ConsultarEstadoYappy', JSON.stringify(llaves)).subscribe(
            (d2) => this.mostrarResultadoYappy(d2 && d2[0] && d2[0].estado ? d2[0] : r),
            () => this.mostrarResultadoYappy(r)
          );
        }, YAPPY_CIERRE_MS);
      }
    },
    () => {
      this.yappyConsultando = false;
    });
  }

    private limpiarAlmacenamientoYappy() {
    for (const almacen of [localStorage, sessionStorage]) {
      try {
        Object.keys(almacen).filter(k => /yappy/i.test(k)).forEach(k => {
          almacen.removeItem(k);
          console.info('[Yappy] clave limpiada:', k);
        });
      } catch (e) { }
    }
  }

  private mostrarResultadoYappy(r: any) {
    this.ngZone.run(() => {
      this.cerrarModalYappy();
      this.yappyFinalizando = false;
      if (this.yappyBoton) { this.yappyBoton.isButtonLoading = false; }
      this.yappyEsperando = false;
      this.yappySinRespuesta = false;
      this.respuestaPago = r;
      this.fechaRespuesta = new Date();
      this.respuestaPagoGeneral = true;
      this.procesando = false;
      this.terminarPago = true;
    });
  }

  private cerrarModalYappy() {
    this.yappyCerrando = true;
    setTimeout(() => { this.yappyCerrando = false; }, 1500);
    try {
      const iconos = Array.from(document.querySelectorAll(
        'app-dialog dialog[open] .close-icon, .yap-boton dialog[open] .close-icon'
      )) as HTMLElement[];
      iconos.forEach(icono => icono.click());
      if (iconos.length) {
        console.info('[Yappy] dialogo de Yappy cerrado (' + iconos.length + ')');
      }
    } catch (e) {
      console.warn('[Yappy] error al cerrar el dialogo de Yappy', e);
    }
  }

  reintentarYappy() {
    this.detenerEsperaYappy();
    this.yappyFinalizando = false;
    this.respuestaPago = null;
    this.respuestaPagoGeneral = false;
    this.terminarPago = false;
    this.procesando = false;
    this.yappyEsperando = false;
    this.yappySinRespuesta = false;
    this.transaccion = 0;
    this.metodoTransaccion = '';
    this.activeTab = 4;
    this.getDatosPago();
  }

  imprimirComprobante() {
    const c = this.comprobante;
    if (!c) {
      return;
    }
    const e = (v: any) => this.escaparHtml(v === null || v === undefined ? '' : String(v));
    const fecha = c.fecha ? new Date(c.fecha).toLocaleString('es-PA') : '';
    const monto = this.simboloDe(c.moneda) + this.formatearMoneda(c.monto);
    const filas = [
      ['Estado', c.aprobado ? 'Pago aprobado' : 'Pago rechazado'],
      ['Fecha', fecha],
      ['Método de pago', c.metodo + (c.tarjeta ? ' · tarjeta •••• ' + c.tarjeta : '')],
      ['Código de autorización', c.autorizacion],
      ['Referencia', c.referencia],
      ['ID de transacción', c.idTransaccion],
      ['Transacción AVATAR', c.transaccion],
      ['Mensaje', c.mensaje]
    ].filter(f => f[1] !== '' && f[1] !== null && f[1] !== undefined)
     .map(f => '<tr><th>' + e(f[0]) + '</th><td>' + e(f[1]) + '</td></tr>').join('');
    const conceptos = (c.conceptos || [])
      .map((x: any) => '<tr><td>' + e(x.M54DES) + '</td><td class="n">' + e(this.simboloDe(c.moneda) + this.formatearMoneda(x.M54MON)) + '</td></tr>').join('');

    const html = '<!doctype html><html lang="es"><head><meta charset="utf-8"><title>Comprobante de pago ' + e(c.transaccion) + '</title>' +
      '<style>body{font-family:Arial,Helvetica,sans-serif;color:#1f2937;margin:32px;max-width:720px}' +
      'h1{font-size:20px;margin:0 0 4px}.sub{color:#6b7280;margin:0 0 24px}' +
      '.monto{font-size:32px;font-weight:700;margin:8px 0 24px}' +
      'table{width:100%;border-collapse:collapse;margin-bottom:24px}th,td{text-align:left;padding:8px 0;border-bottom:1px solid #e5e7eb;font-size:13px;vertical-align:top}' +
      'th{color:#6b7280;font-weight:600;width:40%}.n{text-align:right;white-space:nowrap}' +
      '.estado{display:inline-block;padding:4px 10px;border-radius:12px;font-size:12px;font-weight:700;' +
      (c.aprobado ? 'background:#dcfce7;color:#166534' : 'background:#fee2e2;color:#991b1b') + '}</style></head><body>' +
      '<h1>Comprobante de pago</h1><p class="sub">Transacción No. ' + e(c.transaccion) + '</p>' +
      '<span class="estado">' + (c.aprobado ? 'Pago aprobado' : 'Pago rechazado') + '</span>' +
      '<div class="monto">' + e(monto) + ' <small style="font-size:14px;color:#6b7280">' + e(c.moneda) + '</small></div>' +
      '<table>' + filas + '</table>' +
      (conceptos ? '<h2 style="font-size:14px">Conceptos pagados</h2><table>' + conceptos + '</table>' : '') +
      '<script>window.onload=function(){window.print();}<\/script></body></html>';

    const ventana = window.open('', '_blank');
    if (!ventana) {
      this.mostrarError('El navegador bloqueó la ventana del comprobante. Permite las ventanas emergentes para este sitio.');
      return;
    }
    ventana.document.open();
    ventana.document.write(html);
    ventana.document.close();
  }

  private escaparHtml(texto: string): string {
    return String(texto)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

}
